module.exports = __webpack_public_path__ + "static/media/Transport-law.58f1787b.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/Transport-law.png
// module id = 1385
// module chunks = 1